import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { initializeCalendarsCacheInStore } from 'owa-calendar-cache';
import { getDefaultConnectedAccount } from 'owa-accounts-store';
import { timestamp } from 'owa-datetime';

mutator(initializeCalendarsCacheInStore, actionMessage => {
    const { defaultCalendarEntry } = actionMessage;
    const connectedAccount = getDefaultConnectedAccount();

    if (
        connectedAccount &&
        defaultCalendarEntry.id.mailboxInfo.userIdentity == connectedAccount.userIdentity
    ) {
        getStore().accountCalendarsLoadStartTime = timestamp();
    }
});
